import { render, staticRenderFns } from "./Watching.vue?vue&type=template&id=a40a1920&"
import script from "./Watching.vue?vue&type=script&lang=js&"
export * from "./Watching.vue?vue&type=script&lang=js&"
import style0 from "./Watching.vue?vue&type=style&index=0&id=a40a1920&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports